<template>
    <div class="bg-white border-gray-100 rounded-[20px] custom-shadow-lg p-5 sm:p-6 border dark:bg-gray-800/70 dark:border-transparent">
        <slot></slot>
    </div>
</template>